// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import {
    getPageLinkByNodeId,
    LinkModel,
    useGetLink,
    useGetLinks,
} from "@insite/client-framework/Store/Links/LinksSelectors";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
// import Link from "@insite/mobius/Link"; // Starter Custom Code
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
// import InjectableCss from "@insite/mobius/utilities/InjectableCss"; // Starter Custom Code
import * as cssLinter from "css";
import * as React from "react";
import { FC } from "react";
// import { css } from "styled-components"; // Sas

/* Starter Custom Code - Start */
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import InjectableCss, { StyledProp } from "@insite/mobius/utilities/InjectableCss";
import { inlineSeparatorStyles } from "@store/Themes/common/mixins/typography";
import cssProp from "@toolkit/Framework/Common/Utilities/cssProp";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
/* Starter Custom Code - End */

// Foundation --->
import fieldDefinitionBuilder from "@store/Framework/Features/FieldDefinitionBuilder/fieldDefinitionBuilder";
import { HasResponsive } from "@store/Framework/Features/FieldDefinitionBuilder/FieldDefinitionBuilderTypes";
import { responsiveCss } from "@store/Framework/Features/FieldDefinitionBuilder/Utilities/responsiveCss";
import { FoundationFieldDefinition } from "@store/Framework/Types/FoundationFieldDefinition";
import { contentSpacingStyles } from "@store/Themes/common/mixins/spacing";
import getColor from "@insite/mobius/utilities/getColor";
import { linkStyles } from "@store/Themes/common/mixins/link";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
// <--- Foundation

// Sas
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries, { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { widgetWrapperStyles } from "@store/Library/Components/Toolkit/WidgetWrapper";
import { css, FlattenInterpolation, ThemeProps } from "styled-components";

const enum fields {
    direction = "direction",
    alignment = "alignment",
    title = "title",
    titleLink = "titleLink",
    links = "links",
    customCSS = "customCSS",
    // Starter Custom Code
    showSeparator = "showSeparator",
    // Foundation
    useCustomTextColor = "useCustomTextColor",
    textColor = "textColor",
    // Sas
    useTextColor = "useTextColor",
    centerByBreakpoint = "centerByBreakpoint",
    colorInverted = "colorInverted",
    additionnalsButtons = "additionnalsButtons",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.direction]: "vertical" | "horizontal";
        [fields.alignment]: "left" | "center" | "right";
        [fields.title]: string;
        [fields.titleLink]: LinkFieldValue;
        [fields.links]: LinkModel[];
        [fields.customCSS]: string;
        // Starter Custom Code
        [fields.showSeparator]: boolean;
        // Foundation
        [fields.useCustomTextColor]: boolean;
        [fields.textColor]: string;
        // Sas
        [fields.useTextColor]: boolean;
        [fields.centerByBreakpoint]: string;
        [fields.colorInverted]: boolean;
    } & HasResponsive; // Foundation
    extendedStyles?: LinkListStyles;
}

export interface LinkListStyles {
    linkListWrapper?: InjectableCss;
    titleWrapper?: InjectableCss;
    title?: TypographyPresentationProps;
    linkWrapper?: InjectableCss;
    // Starter Custom Code
    horizontalList?: StyledProp;
    horizontalItem?: StyledProp;
    verticalList?: StyledProp;
    verticalItem?: StyledProp;
    titleLink?: LinkPresentationProps;
    linkStyle?: LinkPresentationProps;
    // Foundation
    linkWrapperHorizontal?: InjectableCss;
    linkWrapperVertical?: InjectableCss;
}

export const linkListStyles: LinkListStyles = {
    linkListWrapper: {
        css: css`
            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            display: flex;
                            justify-content: center;
                            ${contentSpacingStyles(0, 0, pxToRem(15), 0)}
                        `,
                    ],
                    mediaOptions.max,
                )}
        `,
    },
    titleWrapper: {
        css: css`
            font-weight: bold;
            ${contentSpacingStyles(0, 0, "0.5em", 0)}
        `,
    },
    linkWrapper: {},
    linkWrapperHorizontal: {
        css: css`
            display: inline-block;
            ${contentSpacingStyles(0, pxToRem(35), 0, 0, "padding")}
            ${({ theme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            ${contentSpacingStyles(0, pxToRem(8), 0, pxToRem(8), "padding")}
                        `,
                    ],
                    mediaOptions.max,
                )}
        `,
    },
    linkWrapperVertical: {
        css: css`
            padding: ${pxToRem(1)} 0 0 0;
        `,
    },
    linkStyle: {
        css: css`
            ${linkStyles("primary", "text.linkHover", false, false)}
        `,
    },
    title: {
        css: css`
            font-size: ${({ theme }) => theme.design.typography.size.largest};
        `,
    },
};

const defaultCustomCss = `.list-wrapper {
}

.title-wrapper {
}

.list-title {
}

.links-wrapper {
}

.list-link {
}
`;

export const LinkList: FC<OwnProps> = ({ fields, extendedStyles }) => {
    const links = useGetLinks(fields.links, o => o.fields.destination);
    const titleLink = useGetLink(fields.titleLink);
    const styles = useMergeStyles("linkList", linkListStyles, extendedStyles);

    /* Starter Custom Code - Start */
    const listDirectionStyles = css`
        ${fields.direction === "horizontal" ? styles.horizontalList : styles.verticalList}
    `;
    /* Starter Custom Code - End */

    /* Foundation Custom Code - Start */
    const alignmentStyles = responsiveCss(
        fields,
        field => css`
            text-align: ${field.alignment || "right"};
            ${styles.linkListWrapper?.css}
        `,
    );

    const directionStyles = responsiveCss(
        fields,
        field => css`
            ${field.direction === "horizontal" ? styles.linkWrapperHorizontal?.css : styles.linkWrapperVertical?.css};
            ${styles.linkWrapper?.css}
        `,
    );

    const titleStyles = (): LinkPresentationProps => ({
        ...styles.title,
        css: css`
            ${styles.title?.css}
            ${fields.useCustomTextColor
                ? css`
                      color: ${fields.textColor};
                  `
                : css`
                      color: ${getColor("text.link")};
                  `}
        `,
    });

    const routerLinkStyles = (): LinkPresentationProps => ({
        ...styles.linkStyle,
        css: css`
            ${styles.linkStyle?.css}
            ${fields.useCustomTextColor
                ? linkStyles(fields.textColor, fields.textColor, false, false)
                : linkStyles("text.link", null, false, false)}
        `,
    });
    /* Foundation Custom Code - End */

    // Sas --->
    const centerByBreakpointArr: FlattenInterpolation<ThemeProps<BaseTheme>>[] = [];
    centerByBreakpointArr[Number(fields.centerByBreakpoint)] = css`
        ${fields.direction === "horizontal"
            ? css`
                  display: flex;
                  justify-content: center;
                  flex-wrap: wrap;
              `
            : null}
    `;

    const linkListStyle = css`
        ${({ theme }) => breakpointMediaQueries(theme, centerByBreakpointArr, mediaOptions.max) /* Sas */}
    `;

    const linkStylesProps: LinkPresentationProps = {
        css: css`
            ${fields.colorInverted
                ? linkStyles("common.background", null, false, false)
                : linkStyles("inherit", null, false, false)}
        `,
    };

    const customCssWrapper = {
        css: css`
            ${alignmentStyles} /* Foundation */
            ${fields.customCSS}
        `,
    };
    const titleWrapperStyles: InjectableCss = {
        css: css`
            ${styles.titleWrapper.css}
            color: ${getColor(fields.colorInverted ? "common.background" : "text.main")};
        `,
    };
    // <--- Sas

    // Sas --->
    const wrapperStyles = css`
        ${widgetWrapperStyles.css}
        ${alignmentStyles}
    `;
    // <--- Sas

    return (
        <StyledWrapper css={wrapperStyles /* Sas */}>
            {/* Sas */}
            {titleLink.url ? (
                <StyledWrapper {...titleWrapperStyles}>
                    <Link href={titleLink.url}>{fields.title || titleLink.title}</Link>
                </StyledWrapper>
            ) : fields.title ? (
                <StyledWrapper {...titleWrapperStyles}>
                    <Typography as="h3" {...styles.title}>
                        {fields.title}
                    </Typography>
                </StyledWrapper>
            ) : null}
            {/* Sas */}
            <StyledWrapper css={linkListStyle}>
                {links.map(
                    /* Foundation Custom Code - Start */
                    (link, index) =>
                        link?.url && (
                            // eslint-disable-next-line react/no-array-index-key
                            <StyledWrapper key={index} css={directionStyles}>
                                <Link
                                    {
                                        ...routerLinkStyles() /* Foundation */
                                    }
                                    className="list-link"
                                    href={link.url}
                                    target={fields.links[index].fields.openInNewWindow ? "_blank" : "_self"}
                                    // Sas
                                    {...linkStylesProps}
                                >
                                    {fields.links[index].fields.overriddenTitle || link.title}
                                </Link>
                            </StyledWrapper>
                        ),
                    /* Foundation Custom Code - End */
                )}
            </StyledWrapper>
        </StyledWrapper>
    );
};

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const advancedTab = {
    displayName: "Advanced",
    sortOrder: 1,
};

const widgetModule: WidgetModule<FoundationFieldDefinition /* Foundation */> = {
    component: LinkList,
    definition: {
        group: "Basic",
        icon: "ax-link-list",
        fieldDefinitions: [
            // Foundation --->
            ...fieldDefinitionBuilder([
                {
                    name: fields.direction,
                    editorTemplate: "DropDownField",
                    defaultValue: "vertical",
                    fieldType: "General",
                    options: [
                        {
                            displayName: "Vertical",
                            value: "vertical",
                        },
                        {
                            displayName: "Horizontal",
                            value: "horizontal",
                        },
                    ],
                    hideEmptyOption: true,
                    tab: basicTab,
                },
                /* Starter Custom Code - Start */
                {
                    name: fields.showSeparator,
                    editorTemplate: "CheckboxField",
                    fieldType: "General",
                    defaultValue: false,
                    isVisible: x => x.fields.direction === "horizontal",
                    tab: basicTab,
                },
                /* Starter Custom Code - End */
                {
                    name: fields.alignment,
                    editorTemplate: "DropDownField",
                    defaultValue: "left",
                    fieldType: "General",
                    options: [
                        {
                            displayName: "Left",
                            value: "left",
                        },
                        {
                            displayName: "Center",
                            value: "center",
                        },
                        {
                            displayName: "Right",
                            value: "right",
                        },
                        /* Starter Custom Code - Start */
                        {
                            displayName: "Unset",
                            value: "",
                        },
                        /* Starter Custom Code - End */
                    ],
                    hideEmptyOption: true,
                    tab: basicTab,
                },
            ]),
            // <--- Foundation
            {
                name: fields.title,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Contextual",
                tab: basicTab,
            },
            {
                fieldType: "Contextual",
                name: fields.titleLink,
                displayName: "Title Link",
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
                tab: basicTab,
            },
            // Foundation --->
            {
                name: fields.useCustomTextColor,
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
            {
                name: fields.textColor,
                displayName: "Text color",
                editorTemplate: "ColorPickerField",
                defaultValue: "",
                fieldType: "General",
                isVisible: (item: HasFields) => item.fields.useCustomTextColor,
            },
            {
                name: fields.textColor,
                displayName: "Text color",
                editorTemplate: "ColorPickerField",
                defaultValue: "",
                fieldType: "General",
                isVisible: (item: HasFields) => item.fields.useCustomTextColor,
            },
            // <--- Foundation
            {
                name: fields.links,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields, state) => {
                    const {
                        destination: { type, value },
                        overriddenTitle,
                    } = item.fields;
                    if (overriddenTitle) {
                        return overriddenTitle;
                    }
                    if (type === "Page") {
                        const link = getPageLinkByNodeId(state, value);
                        return link?.title;
                    }
                    if (type === "Category") {
                        let displayValue = "";
                        const categories = (state as any).pageEditor.categories;
                        if (!categories) {
                            displayValue = "Loading...";
                        } else {
                            const matchingCategories = categories.filter((o: { id: string }) => o.id === value);
                            if (matchingCategories.length === 0) {
                                displayValue = "Unknown";
                            } else {
                                displayValue = matchingCategories[0].shortDescription;
                            }
                        }

                        return displayValue;
                    }
                    if (type === "Url") {
                        return value;
                    }
                    return value;
                },
                defaultValue: [],
                fieldType: "Contextual",
                fieldDefinitions: [
                    {
                        name: "destination",
                        editorTemplate: "LinkField",
                        defaultValue: {
                            value: "",
                            type: "Page",
                        },
                        isRequired: true,
                    },
                    {
                        name: "overriddenTitle",
                        displayName: "Title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "openInNewWindow",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                    },
                ],
                tab: basicTab,
            },
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "General",
                tab: advancedTab,
                defaultValue: defaultCustomCss,
                isVisible: (item, shouldDisplayAdvancedFeatures) => !!shouldDisplayAdvancedFeatures,
                validate: value => {
                    if (value === undefined || value === null) {
                        return "";
                    }

                    const result = cssLinter.parse(value, { silent: true });
                    if (result?.stylesheet?.parsingErrors) {
                        // the error output at this time only has room for one line so we just show the first error
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                    }

                    return "Unable to parse Css";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
            // Store Custom Code
            {
                name: fields.colorInverted,
                displayName: "Invert Color",
                editorTemplate: "CheckboxField",
                fieldType: "General",
                defaultValue: false,
            },
            {
                name: fields.centerByBreakpoint,
                displayName: "Center By Page Size",
                fieldType: "General",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "X-Small (600px)", value: 0 },
                    { displayName: "Small (900px)", value: 1 },
                    { displayName: "Medium (1200px)", value: 2 },
                    { displayName: "Large (1500px)", value: 3 },
                    { displayName: "X-Large (1500px+)", value: 4 },
                    { displayName: "None", value: 5 },
                ],
                defaultValue: 5,
            },
        ],
    },
};

export default widgetModule;
